(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9176],{

/***/ 81818:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ho-tro",
      function () {
        return __webpack_require__(82277);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83554);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42031);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7806);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95298);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);






var SupportPage = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("layout").t;
    var pageItems = [
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.PrivacyPolicyPage */ ._.PrivacyPolicyPage,
            type: "link",
            text: t("footer.page.privacy-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.RefundPolicyPage */ ._.RefundPolicyPage,
            type: "link",
            text: t("footer.page.refund-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.DepositPolicyPage */ ._.DepositPolicyPage,
            type: "link",
            text: t("footer.page.deposit-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.CustomerLevelInfo */ ._.CustomerLevelInfo,
            type: "link",
            text: t("footer.page.customer-level-info")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.CustomerBenefitPolicyPage */ ._.CustomerBenefitPolicyPage,
            type: "link",
            text: t("footer.page.customer-benefit-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.ProductWarrantyPolicyPage */ ._.ProductWarrantyPolicyPage,
            type: "link",
            text: t("footer.page.product-warranty-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.PaymentGuidePolicyPage */ ._.PaymentGuidePolicyPage,
            type: "link",
            text: t("footer.page.payment-guide")
        },
        {
            path: "https://www.anthu.vn/article/mua-hang-tra-gop-tai-kim-cuong-an-thu/",
            type: "link",
            text: t("footer.page.payment-installment")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.CheckoutPolicyPage */ ._.CheckoutPolicyPage,
            type: "link",
            text: t("footer.page.checkout-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.ShippingAndDeliveryPolicyPage */ ._.ShippingAndDeliveryPolicyPage,
            type: "link",
            text: t("footer.page.shipping-and-delivery-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.ConsignPolicyPage */ ._.ConsignPolicyPage,
            type: "link",
            text: t("footer.page.consign-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.RentalPolicyPage */ ._.RentalPolicyPage,
            type: "link",
            text: t("footer.page.rent-policy")
        },
        {
            path: _layouts_shared__WEBPACK_IMPORTED_MODULE_3__/* .PagePath.MeasuringGuidePage */ ._.MeasuringGuidePage,
            type: "link",
            text: t("footer.page.measuring-guide")
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "Hỗ trợ kh\xe1ch h\xe0ng",
                description: "Hỗ trợ kh\xe1ch h\xe0ng"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-px-0 lg:tw-px-10 tw-text-base tw-leading-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase",
                            children: "Hỗ trợ kh\xe1ch h\xe0ng"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-grid tw-mt-10 tw-grid-cols-1 md:tw-grid-cols-2 tw-w-full tw-mx-auto tw-gap-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "md:tw-border-r tw-border-primary-main tw-flex tw-flex-col tw-gap-4",
                                    children: pageItems.slice(0, pageItems.length / 2).map(function(item, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                            url: item.path,
                                            className: "tw-flex tw-items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                                                    src: "/diamond.svg",
                                                    alt: "diamond",
                                                    className: "tw-w-6 tw-h-6 tw-mr-2"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "tw-text-black",
                                                    children: item.text
                                                })
                                            ]
                                        }, "page-link-".concat(index));
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tw-flex tw-flex-col tw-gap-4 lg:tw-pl-10",
                                    children: [
                                        pageItems.slice(pageItems.length / 2, pageItems.length).map(function(item, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                url: item.path,
                                                className: "tw-flex tw-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                                                        src: "/diamond.svg",
                                                        alt: "diamond",
                                                        className: "tw-w-6 tw-h-6 tw-mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "tw-text-black",
                                                        children: item.text
                                                    })
                                                ]
                                            }, "page-link-".concat(index));
                                        }),
                                        " "
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SupportPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(81818); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);